const currencies = {
    EU: {
        currency: "€",
        label: "EUR"
    }
} as any;

export default currencies;